"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAuthroizationRequired = exports.getProofStrategy = exports.isProofRequired = exports.getEndDateInterval = exports.getStartDateInterval = exports.getRegistrationEndInterval = exports.isElectionEditable = exports.isElectionOnline = exports.canAddChoice = exports.canAddQuestion = exports.assertPoll = exports.prepareViewQustions = exports.prepareQuestions = exports.prepareEmptyChoice = exports.truncatePoll = void 0;
const consts_1 = require("./consts");
const types_1 = require("./types");
require("dayjs/plugin/duration.js");
const dayjs_1 = __importDefault(require("dayjs"));
const vocdoni_1 = require("../vocdoni");
const proofspace_1 = require("../proofspace");
const telegram_1 = require("../telegram");
const ui_1 = require("../../ui");
const utils_1 = require("../utils");
const newbelarus_1 = require("../newbelarus");
const truncatePoll = (poll) => {
    if (poll.questions == null) {
        return Object.assign(Object.assign({}, poll), { questions: [
                {
                    title: '',
                    description: '',
                    choices: [
                        (0, exports.prepareEmptyChoice)(poll, 0),
                        (0, exports.prepareEmptyChoice)(poll, 1)
                    ]
                }
            ] });
    }
    return Object.assign(Object.assign({}, poll), { questions: poll.questions.slice(0, consts_1.POLL_QUESTION_MAX - 1).map(question => (Object.assign(Object.assign({}, question), { choices: question.choices.slice(0, consts_1.POLL_CHOICE_MAX - 1) }))) });
};
exports.truncatePoll = truncatePoll;
const prepareEmptyChoice = (poll, value) => {
    switch (poll.uiType) {
        case ui_1.RENDERER_PARTY:
            return {
                title: '', value, meta: {
                    avatar: { fullUrl: '', type: utils_1.ContentImageType.Remote }
                }
            };
    }
    return { title: '', value };
};
exports.prepareEmptyChoice = prepareEmptyChoice;
const prepareQuestions = (poll) => {
    var _a, _b, _c, _d, _e;
    switch (poll.uiType) {
        case ui_1.RENDERER_PARTY:
            return [{
                    title: { default: poll.title },
                    description: { default: (_a = poll.description) !== null && _a !== void 0 ? _a : '' },
                    choices: (_c = (_b = poll.questions) === null || _b === void 0 ? void 0 : _b.map((question, index) => ({
                        title: { default: question.title },
                        value: index
                    }))) !== null && _c !== void 0 ? _c : []
                }];
    }
    return (_e = (_d = poll.questions) === null || _d === void 0 ? void 0 : _d.map(question => {
        var _a;
        return ({
            title: { default: question.title },
            description: { default: (_a = question.description) !== null && _a !== void 0 ? _a : '' },
            choices: question.choices.map(choice => ({
                title: { default: choice.title },
                value: choice.value
            }))
        });
    })) !== null && _e !== void 0 ? _e : [];
};
exports.prepareQuestions = prepareQuestions;
const prepareViewQustions = (poll) => {
    const questions = (0, exports.prepareQuestions)(poll);
    return questions.map(question => {
        var _a;
        return ({
            title: question.title.default,
            description: (_a = question.description) === null || _a === void 0 ? void 0 : _a.default,
            choices: question.choices.map(choice => ({
                title: choice.title.default,
                value: choice.value
            }))
        });
    });
};
exports.prepareViewQustions = prepareViewQustions;
const assertPoll = (poll) => {
    var _a;
    if (poll.questions != null && poll.questions.length > consts_1.POLL_QUESTION_MAX) {
        return false;
    }
    return ((_a = poll.questions) === null || _a === void 0 ? void 0 : _a.some(question => question.choices.length > consts_1.POLL_CHOICE_MAX)) !== true;
};
exports.assertPoll = assertPoll;
const canAddQuestion = (poll) => {
    var _a, _b;
    return ((_b = (_a = poll.questions) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) < consts_1.POLL_QUESTION_MAX;
};
exports.canAddQuestion = canAddQuestion;
const canAddChoice = (poll, index) => {
    if (poll.questions == null || poll.questions[index] == null) {
        return false;
    }
    return poll.questions[index].choices.length < consts_1.POLL_CHOICE_MAX;
};
exports.canAddChoice = canAddChoice;
const isElectionOnline = (poll) => ![types_1.PollStatus.UNPUBLISHED, types_1.PollStatus.PUBLISHED].includes(poll.status);
exports.isElectionOnline = isElectionOnline;
const isElectionEditable = (poll) => [types_1.PollStatus.UNPUBLISHED].includes(poll.status);
exports.isElectionEditable = isElectionEditable;
const getRegistrationEndInterval = (poll) => dayjs_1.default.duration((0, dayjs_1.default)(poll.registrationEnd).diff((0, dayjs_1.default)(new Date())));
exports.getRegistrationEndInterval = getRegistrationEndInterval;
const getStartDateInterval = (poll) => dayjs_1.default.duration((0, dayjs_1.default)(poll.startDate).diff((0, dayjs_1.default)(new Date())));
exports.getStartDateInterval = getStartDateInterval;
const getEndDateInterval = (poll) => dayjs_1.default.duration((0, dayjs_1.default)(poll.endDate).diff((0, dayjs_1.default)(new Date())));
exports.getEndDateInterval = getEndDateInterval;
const isProofRequired = (poll) => poll.requiredProofs != null && poll.requiredProofs.length > 0;
exports.isProofRequired = isProofRequired;
const getProofStrategy = (poll, { preferedStrategy, hiddenStrategies }) => {
    if ((0, exports.isProofRequired)(poll) && poll.requiredProofs != null) {
        const proofs = poll.requiredProofs.filter(proof => proof.type !== telegram_1.TELEGRAM_STRATEGY)
            .filter(proof => proof.type !== newbelarus_1.NEWBELARUS_STRATEGY
            || (proof.type === newbelarus_1.NEWBELARUS_STRATEGY && preferedStrategy === newbelarus_1.NEWBELARUS_STRATEGY))
            .filter(proof => hiddenStrategies == null || !hiddenStrategies.includes(proof.type))
            .map(proof => proof.type);
        if ((proofs.length < 2 || preferedStrategy === newbelarus_1.NEWBELARUS_STRATEGY)
            && preferedStrategy != null && proofs.includes(preferedStrategy)) {
            return preferedStrategy;
        }
        if (proofs.length > 1) {
            return consts_1.MULTIPROOF_STRATEGY;
        }
        if (proofs[0] != null) {
            return proofs[0];
        }
    }
    return proofspace_1.PROOFSPACE_STRATEGY;
};
exports.getProofStrategy = getProofStrategy;
const isAuthroizationRequired = (poll) => { var _a; return (0, exports.isProofRequired)(poll) && vocdoni_1.VOCDONI_CSP_CENSUSES.includes((_a = poll.census) === null || _a === void 0 ? void 0 : _a.type); };
exports.isAuthroizationRequired = isAuthroizationRequired;
